<template>
  <div class="main previewMain">
    <!-- 顶部 -->
    <div class="top">
      <img class="goback" src="../assets/back.png" @click="goback" />
      <span>返回</span>
      <span class="declarePre">申报表预览</span>
    </div>

    <div style="margin: 0 10px;">
      <Declaration
        :isShowBtn="false"
        :form="formData"
        :awardList="awardList"
        :isDisabled="true"
        :isPreview="true"
      ></Declaration>
    </div>

    <!-- 技术采用情况介绍 -->
    <div class="captionBox">
      <p class="caption" style="color: #00b0f0;">技术采用情况介绍</p>
      <p class="download" @click="downloadPackageOfTechAndInno">一键打包下载（技术+创新）</p>
    </div>
    <div class="commonItem" v-for="(item, index) in formData.declareLevelDtos" :key="index">
      <p class="title" style="color: #00b0f0;">{{item.level_name}}</p>
      <p class="description">技术情况说明：</p>
      <div class="textArea">
        <el-input
          v-model="item.technology_introduce"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          disabled
        ></el-input>
        <div class="downloadDetail">
          <p>
            <img src="../assets/zip.png" alt @click="downloadSingleTec(item)" />
          </p>
          <p @click="downloadSingleTec(item)">下载该材料</p>
        </div>

      </div>
    </div>

    <!-- 创新项采用情况介绍 -->
    <div v-if="formData.innovateTechnologyDtos && formData.innovateTechnologyDtos.length">
      <div class="captionBox">
        <p class="caption" style="color: #ff8f14;">创新项采用情况介绍</p>
        <p class="download" @click="downloadPackageOfInno">一键打包下载</p>
      </div>
      <div class="commonItem" v-for="(item, index) in formData.innovateTechnologyDtos" :key="index">
        <p class="title" style="color: #ff8f14;">{{item.it_name}}</p>
        <p class="description">技术情况说明：</p>
        <div class="textArea">
          <el-input
            type="textarea"
            v-model="item.introduce"
            :autosize="{ minRows: 5, maxRows: 8}"
            disabled
          ></el-input>
          <div class="downloadDetail">
          <p>
            <img src="../assets/zip.png" alt @click="downloadSingleInnovate(item)" />
          </p>
          <p @click="downloadSingleInnovate(item)">下载该材料</p>
        </div>
        </div>
        <p class="description">自评分：{{item.score}}</p>
      </div>
    </div>

    <!-- 形审补充资料 -->
    <Examine
      :isOdd="true"
      :caption="'形审补充资料'"
      :backDeclareLevel="formData.declareLevelDtosXS"
      :backInnovateTechnology="formData.innovateTechnologyDtosXS"
      :backOverview="formData.overviewXS"
      :backBenefit="formData.benefitXS"
      :backOperability="formData.operabilityXS"
      :backOverviewPic="formData.overviewPICXS"
      :backBenefitPic="formData.benefitPICXS"
      :backOperabilityPic="formData.operabilityPICXS"
    />

    <!-- 初审补充资料 -->
    <Examine
      :isOdd="false"
      :caption="'初审补充资料'"
      :backDeclareLevel="formData.declareLevelDtosCS"
      :backInnovateTechnology="formData.innovateTechnologyDtosCS"
      :backOverview="formData.overviewCS"
      :backBenefit="formData.benefitCS"
      :backOperability="formData.operabilityCS"
      :backOverviewPic="formData.overviewPICCS"
      :backBenefitPic="formData.benefitPICCS"
      :backOperabilityPic="formData.operabilityPICCS"
    />

    <!-- 评审补充资料 -->
    <Examine
      :isOdd="true"
      :caption="'评审补充资料'"
      :backDeclareLevel="formData.declareLevelDtosPS"
      :backInnovateTechnology="formData.innovateTechnologyDtosPS"
      :backOverview="formData.overviewPS"
      :backBenefit="formData.benefitPS"
      :backOperability="formData.operabilityPS"
      :backOverviewPic="formData.overviewPICPS"
      :backBenefitPic="formData.benefitPICPS"
      :backOperabilityPic="formData.operabilityPICPS"
    />

    <div style="text-align: center;margin-bottom: 50px;">
      <el-button type="primary" @click="close">关闭</el-button>
    </div>
  </div>
</template>

<script>
import Declaration from '../components/Declaration'
import Examine from '../components/Examine'
import * as API from '../utils/apiService'
import config from '../config'

const { downloadUrl } = config
export default {
  components: { Declaration, Examine },
  data () {
    return {
      id: '',
      awardList: [
        {
          bear_palm_time: '',
          bear_palm_name: '',
          bear_palm_grade: '',
          bear_palm_branch: ''
        }
      ],
      formData: {
        declareLevelDtos: [], // 技术目录
        constructioncompanyList: [{ construction_company_name: '' }],
        unitecompanyList: [
          {
            unite_company_name: ''
          }
        ],
        items_name: '', // 申报项目名称
        company_name: '', // 主申报单位
        construction_place: '', // 项目建设地点
        construction_time: '', // 项目竣工时间
        address: '', // 联系地址
        legal_person: '', // 主申报单位法人
        legal_person_phone: '', // 电话
        linkman: '', // 联系人
        position: '', // 职务
        email: '', // 邮箱
        cellphone: '', // 手机
        telephone: '', // 座机
        fax: '', // 传真
        award: '', // 现有评定类型
        award_type: 3, // 申报评定类型
        project_type: [], // 项目类型
        overview: '', // 项目概况
        benefit: '', // 社会效益和经济效益
        operability: '', // 可操作性和示范性
        overviewPICs: [], // 项目概况图片
        benefitPICs: [], // 社会效益和经济效益图片
        operabilityPICs: [], // 可操作性和示范性图片
        overviewPIC: [], // 请求返回的项目概况图片路径集合
        benefitPIC: [], // 请求返回的社会效益和经济效益图片路径集合
        operabilityPIC: [], // 请求返回的可操作性和示范性图片路径集合

        overviewPICXS: [], // 返回的形审图片路径集合（项目概况）
        benefitPICXS: [], // 返回的形审图片路径集合（社会效益和经济效益）
        operabilityPICXS: [], // 返回的形审图片路径集合（可操作性和示范性）

        overviewPICCS: [], // 返回的初审图片集合（项目概况）
        benefitPICCS: [], // 返回的初审图片集合（社会效益和经济效益）
        operabilityPICCS: [], // 返回的初审图片集合（可操作性和示范性）

        overviewPICPS: [], // 返回的评审图片集合（项目概况）
        benefitPICPS: [], // 返回的评审图片集合（社会效益和经济效益）
        operabilityPICPS: [] // 返回的评审图片集合（可操作性和示范性）
      }
    }
  },
  mounted () {
    let params = {
      id: this.$route.query.id
    }
    API.getEBByID(params).then(resp => {
      if (resp.resultCode === '0000') {
        this.formData = {
          ...resp.data,
          overviewPICs: [],
          benefitPICs: [],
          operabilityPICs: [],
          project_type: resp.data.project_type
            ? resp.data.project_type.split(',')
            : [],
          unitecompanyList: resp.data.unite_company_name
            .split(',')
            .map(item => ({ unite_company_name: item })),
          constructioncompanyList: resp.data.construction_company_name
            .split(',')
            .map(item => ({ construction_company_name: item }))
        }
        this.awardList = !resp.data.projectWinHistoryDtos.length
          ? [
            {
              bear_palm_time: '',
              bear_palm_name: '',
              bear_palm_grade: '',
              bear_palm_branch: ''
            }
          ]
          : resp.data.projectWinHistoryDtos
      }
    })
  },
  methods: {
    goback () {
      this.$router.go(-1)
    },
    close () {
      this.$router.go(-1)
    },

    // 一键打包下载技术+创新
    downloadPackageOfTechAndInno () {
      let params = {
        project_declare_id: this.$route.query.id
      }
      API.downloadDeclareAndInno(params).then(resp => {
        if (resp.resultCode === '0000') {
          let path = downloadUrl + resp.data
          window.open(path, '_self')
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
    },

    // 下载单个技术目录
    downloadSingleTec (item) {
      let params = {
        project_declare_id: item.project_declare_id,
        state: item.state,
        level_id: item.level_id
      }
      API.downLoadOneDeclareLevel(params).then(resp => {
        if (resp.resultCode === '0000') {
          let path = downloadUrl + resp.data
          window.open(path, '_self')
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
    },

    // 一键打包下载(创新)
    downloadPackageOfInno () {
      let params = {
        project_declare_id: this.$route.query.id
      }
      API.downLoadAllInno(params).then(resp => {
        if (resp.resultCode === '0000') {
          let path = downloadUrl + resp.data
          window.open(path, '_self')
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
    },

    // 下载单个创新项
    downloadSingleInnovate (item) {
      let params = {
        project_declare_id: item.project_declare_id,
        it_name: item.it_name
      }
      API.downloadOneInno(params).then(resp => {
        if (resp.resultCode === '0000') {
          let path = downloadUrl + resp.data
          window.open(path, '_self')
        } else {
          this.$message.error(resp.resultMsg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.previewMain {
  .declarePre {
    color: #00b0f0;
    font-size: 20px;
    font-weight: 500;
    margin-left: 35%;
  }
  .captionBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8f8f8;
    height: 30px;
    width: 98%;
    margin: 50px 0 20px 0;
    .caption {
      margin-left: 80px;
      font-size: 16px;
    }
    .download {
      color: #00b0f0;
      margin-right: 150px;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .commonItem {
    margin-bottom: 50px;
    .title {
      font-size: 16px;
      margin-left: 100px;
      margin-bottom: 14px;
    }
    .description {
      color: #717171;
      font-size: 14px;
      margin-left: 140px;
      margin-bottom: 16px;
    }
    .textArea {
      display: flex;
      width: 70%;
      margin-left: 200px;
      margin-bottom: 20px;
      .downloadDetail{
        width:100px;
        margin-left:50px;
        font-size: 14px;
        cursor: pointer;
        text-align:center;
        text-decoration: underline;
      }
    }
  }
}
</style>
